import { action, computed, observable } from "mobx";
import { store } from "@store";
import { downloadViaNewTab } from "@api";
import locale from "@bonliva-crm/locale";
import {
  BookingFinanceSearch_Get,
  BookingFinanceSearch_CSV,
  BookingFinanceSearch_CSV_bg,
  BookingFinanceSearch_GetTotal,
  BookingFinanceSearchItemFragment,
  BookingCSVReportType
} from "@graphql";
import { BookingSearchStore } from "../BookingSearchStore";

export class BookingFinanceSearchStore extends BookingSearchStore<BookingFinanceSearchItemFragment> {
  @observable private _isDownloading = false;

  constructor() {
    super(BookingFinanceSearch_Get, checkCustomInvoiceNo, (filter) =>
      BookingFinanceSearch_GetTotal.func(
        { filter },
        { fetchPolicy: "network-only" }
      ).then((x) => x.data.bookingWeeksTotal.total)
    );
    this.filterManager.hideFields(["assignedPersons"]);
    (window as any).bookingFinanceSearchStore = this;
  }

  @computed get isDownloading() {
    return this._isDownloading;
  }

  @action.bound getCSV(type: BookingCSVReportType) {
    this._isDownloading = true;

    BookingFinanceSearch_CSV.func(
      { filter: this.filterManager.queryInput, type },
      { fetchPolicy: "network-only" }
    )
      .then(({ data }) => {
        return downloadViaNewTab(data.bookingWeeksCSV.URL);
      })
      .catch((e) => {
        store().snackbars.error(`Cannot download file\nReason: ${e}`);
      })
      .finally(() => {
        this._isDownloading = false;
      });
  }

  @action.bound getCSVBg(type: BookingCSVReportType) {
    this._isDownloading = true;

    BookingFinanceSearch_CSV_bg.func(
      { filter: this.filterManager.queryInput, type },
      { fetchPolicy: "network-only" }
    )
      .then(({ data }) => {
        store().snackbars.success(`${data.bookingWeeksCSVBackground.result}`);
      })
      .catch((e) => {
        store().snackbars.error(`Cannot download file\nReason: ${e}`);
      })
      .finally(() => {
        this._isDownloading = false;
      });
  }
}

/**
 * Crutches for 888888, 999999, and similar invoices
 * @param item
 */

function checkCustomInvoiceNo(
  item: BookingFinanceSearchItemFragment
): BookingFinanceSearchItemFragment {
  const { specialInvoices } = store().cache;

  const specialInvoiceNumbers = Object.keys(specialInvoices);
  const invNumbers: string[] = [];

  for (const num of item.InvoiceNumbers || []) {
    const invNum = specialInvoiceNumbers.includes(num.toString())
      ? locale.bookingInvoiceType[specialInvoices[num.toString()]]
      : num;

    invNumbers.push(invNum);
  }

  return {
    ...item,
    InvoiceNumbers: invNumbers
  };
}
